export default __webpack_public_path__ + "static/media/Slider_Research1.2085b9e9.mp4";